/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { CreditCard } from '../models/CreditCard';
import { HttpFile } from '../http/http';

/**
* Create Credit Card Request
*/
export class CreateCreditCardRequest {
    'creditCard'?: CreditCard;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "creditCard",
            "baseName": "credit_card",
            "type": "CreditCard",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return CreateCreditCardRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

